/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-04-07 15:43:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2022-06-17 17:37:45
 * @FilePath: \baishu_react_ui\src\components\BsyTableContainer\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import React, { Component } from 'react'
 

export default class BsyTableContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // widgetName: this.props.attr.widgetName,
      items: this.props.attr.items,
    }
  }

  componentDidMount = () => {
 
  }

  componentWillUnMount = () => {
 
  }

  _renderRows = () => {

    const { rowSize, vgap } = this.props.attr;
    //处理每一行
    rowSize.map((item, index) => {
      let divStyle = {};
      if (index > 0) {
        divStyle = {
          "marginTop": vgap
        }
      }
      return <div className='x-layout-table-row' style={divStyle} >{
        this._renderClos(index)
      }</div>
    })
  }

  _renderClos = (row) => {
    const { hgap, colSize, rowSize, items } = this.props.attr;
 
  }

  render() {
    return (
      <div className="x-layout-table" style={this.state.css} >
 
      </div>
    )
  }
}
